<template>
    <div>
        <div class="drop" v-if="images.length <= 0">
            <strong><i class="fa-regular fa-image"></i> Gallery</strong>
            <span>Drag and drop to upload files or </span>
            <a class="btn btn_primary-outline pl-5 pr-5 mt-3" @click="$refs.imageInput.click()">Select Files</a>
        </div>

        <div v-else>
            <span class="form-label">Gallery</span>
            <div class="files">
                <div class="files__item" v-for="(image, index) in images" :key="index">
                    <a :href="`/uploads/${image}`" target="_blank">
                        <img :src="`/uploads/${image}`" alt="Photo" width="120">
                    </a>
                    <button type="button" class="files__delete" @click="deleteImage(index)">
                        <svg width="12" height="12" aria-hidden="true">
                            <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                        </svg>
                    </button>
                    <span class="files__num">{{ index + 1 }}</span>
                </div>
            </div>
            <div class="add-link mt-3">
                <a href="javascript:void(0)" @click="$refs.imageInput.click()">+ Add Photo</a>
            </div>
        </div>

        <input
            type="file"
            style="display: none"
            ref="imageInput"
            accept="image/*"
            multiple
            @change="selectFiles"
        >
    </div>
</template>

<script>
import { defineComponent } from 'vue'


export default defineComponent({
    name: 'MultipleImage',
    props: {
        uploadedImages: {
            type: Array,
        },
        uploadHandler: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            images: [],
            files: []
        }
    },
    methods: {
        deleteImage(index) {
            try {
                this.images = this.images.filter((_, i) => i !== index);
                this.$showSuccessMessage('The photo was deleted')
                this.emitGalleryData()
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The photo was not deleted')
            }
        },
        async selectFiles() {
            const uploadedFiles = this.$refs.imageInput.files
            const validFiles = await this.validateAndPrepareFiles(uploadedFiles)

            if (validFiles.length === 0) return

            this.files = [
                ...new Map([...this.files, ...uploadedFiles].map(item => [item.name, item])).values()
            ]

            await this.sendPhoto(validFiles)
        },
        async sendPhoto(files) {
            this.$showLoadingMessage()
            const formData = new FormData()
            for (let i = 0; i < files.length; i++) {
                formData.append('files[]', files[i].file)
            }

            try {
                const { data: response } = await this.uploadHandler(formData)

                let newImages = []

                if (Array.isArray(response)) {
                    newImages = response.map(img => img.file_path)
                } else if (response && typeof response === 'object') {
                    newImages = [response.file_path]
                }

                this.images = [...this.images, ...newImages]
                this.emitGalleryData()
                this.files = []
                this.$showSuccessMessage('The photo/s was uploaded')
            } catch (error) {
                this.$showErrorMessage()
            }
        },

        async validateAndPrepareFiles(uploadedFiles) {
            const MAX_FILE_SIZE = 150 * 1024 * 1024
            const files = await Promise.all(
                Array.from(uploadedFiles).map(async (file) => {
                    if (file.size > MAX_FILE_SIZE) {
                        this.$showErrorMessage(`The file ${file.name} exceeds the maximum size of 150 MB.`)
                    } else {
                        try {
                            const content = await this.readFileAsync(file)
                            return {
                                file,
                                name: file.name,
                                content
                            }
                        } catch (error) {
                            console.error('Помилка при читанні файлу:', error)
                            return null
                        }
                    }
                })
            )
            return files.filter(Boolean)
        },
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => resolve(reader.result)
                reader.onerror = reject
                reader.readAsDataURL(file)
            })
        },
        emitGalleryData() {
            this.$emit('update-content', this.images)
        }
    },

    mounted() {
        if (this.uploadedImages) {
            this.images = this.uploadedImages
            this.emitGalleryData()
        }
    }
})
</script>
